document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".reviews-text-and-image-swiper", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 20,
    centeredSlides: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    breakpoints: {
      1280: {
        slidesPerView: 3,
      },
      1536: {
        slidesPerView: 3.5,
        centeredSlides: false,
      },
    },
  });
});
